module.exports = __webpack_public_path__ + "static/media/nightCream.86b960e3.png";